import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[savingStatus]'
})
export class SavingStatusDirective {

  @Input('savingStatus') set savingStatus(val) {
    val ? this.addLoader() : this.removeLoader();
  };
  @Input('savingStatusPosition') savingStatusPosition = null;
  private loader = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  addLoader() {
    this.renderer.addClass(this.el.nativeElement, 'saving-status-pos');
    const loader = this.renderer.createElement('div');
    this.renderer.addClass(loader, 'saving-status');
    if (this.savingStatusPosition) {
      this.renderer.addClass(loader, this.savingStatusPosition);
    }
    this.renderer.appendChild(this.el.nativeElement, loader);
    this.loader = loader;
    setTimeout(() => this.renderer.addClass(loader, 'in-progress'), 200);
  }

  removeLoader() {
    if (this.loader) {
      this.renderer.removeClass(this.loader, 'in-progress');
      setTimeout(() => this.renderer.addClass(this.loader, 'is-complete'), 200);
      setTimeout(() => {
        this.renderer.removeClass(this.el.nativeElement, 'saving-status-pos');
        this.renderer.removeChild(this.el.nativeElement, this.loader);
      }, 1000);
    }
  }

}